export default "__VITE_ASSET__CWYOm0TY__"